import { render, staticRenderFns } from "./ContentPageHeader.vue?vue&type=template&id=9e5e4802&"
import script from "./ContentPageHeader.vue?vue&type=script&lang=js&"
export * from "./ContentPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports